/**
 * Localization messages for RuleCardHeader component
 */
import sharedMessages from '../../../../shared/messages/sharedMessages';
import { mergeInvertedMessages } from '../../../../utils/localization';

const componentMessages = {
  // add component-specific messages here
} as const;

const invertedMessages = mergeInvertedMessages(
  sharedMessages,
  componentMessages
);

export type RuleCardHeaderMessage = keyof typeof invertedMessages;

export default invertedMessages;
